<div class="d-flex w-100">
  <div class="col-12 col-md-8 col-lg-7 left-container">
      <h3 class="m-0 ">{{ "Login" | translate }}</h3>
    <p>{{ "Welcome Back" | translate }}</p>


    <!-- ─── Social Buttons ─── -->
    <div class="social-row mt-4">
        <button class="google-btn border-0" (click)="loginWithGoogle()" type="button">
          <img src="../../../../assets/img/google.svg" alt="Google" />
          {{ "Signup with Google" | translate }}
        </button>
        <button class="linkedin-btn" (click)="loginWithLinkedIn()" type="button">
          <img src="../../../../assets/img/linkedIn-auth.svg" alt="LinkedIn" />
          {{ "Signup with LinkedIn" | translate }}
        </button>
      </div>

      <div class="or-divider mt-2">
        <div class="line"></div>
        <label>{{ "Or" | translate }}</label>
        <div class="line"></div>
      </div>

    <!-- ─── Email ─── -->
    <div class="mt-2">
      <label>{{ "Email" | translate }}</label>
    <div class="input-container mt-1">
  <i class="bi bi-envelope left-icon"></i>
  <input
    name="email"
    [(ngModel)]="email"
    #emailCtrl="ngModel"
    required
    type="email"
    placeholder="{{ 'Enter your email' | translate }}"
    autocomplete="email"
    (blur)="emailCtrl.control.markAsTouched()"
  />
</div>
<div class="error-message" *ngIf="emailCtrl.invalid && emailCtrl.touched">
  {{ "Email is required" | translate }}
</div>
    </div>

    <!-- ─── Password ─── -->
    <div class="mt-3">
      <label>{{ "Password" | translate }}</label>
<div class="input-container mt-1">
  <i class="bi bi-lock left-icon"></i>
  <input
    name="password"
    [(ngModel)]="password"
    #passwordCtrl="ngModel"
    required
    [type]="showPassword ? 'text' : 'password'"
    placeholder="{{ 'Enter your password' | translate }}"
    autocomplete="current-password"
    (blur)="passwordCtrl.control.markAsTouched()"
  />
  <i
    class="eye-icon {{ showPassword ? 'bi-eye-slash' : 'bi bi-eye' }}"
    (click)="toggleShowPassword()"
  ></i>
</div>
<div class="error-message" *ngIf="passwordCtrl.invalid && passwordCtrl.touched">
  {{ "Password is required" | translate }}
</div>
    </div>

    <!-- ─── Forget Password ─── -->
    <div class="bold-text mt-2 forget" routerLink="/forget-password">
      {{ "Forget my password?" | translate }}
    </div>

    <!-- ─── Login Button ─── -->
    <button (click)="loginAsUser()" class="w-100 gradient-button mt-3" type="button">
      {{ "Login" | translate }}
    </button>

    <!-- ─── Create Account ─── -->
    <div class="text-center mt-4">
      {{ "Create an account?" | translate }}
      <span class="bold-text" routerLink="/sign-up">{{ "Signup" | translate }}</span>
    </div>
  </div>

  <!-- ─── Right Container ─── -->
  <div class="d-none d-md-flex col-md-4 col-lg-5 right-container">
    <img class="logo-img" src="../../../../assets/img/logo.png" alt="Logo" />
    <img class="auth-group-img mt-3" src="../../../../assets/img/authGroup.svg" alt="Auth Group" />
  </div>
</div>